import React from 'react';

import FormItemContainer from './FormItemContainer';
import FormItemUtil from '../utils/FormItemUtil';


class FormItemTable extends FormItemContainer
{
	constructor(props)
	{
		super(props);
    }
    
	render()
	{
        let parent = this.props.xml;
        let children = parent.FormItem;
        let that = this;
        var _style = Object.assign({},this.props.customStyle);
        let list = children.map(function(item){
			return FormItemUtil.getFormItemInstance(that.props.menuItemId,that.props.formId,item,parent,that.props.forLookup);
        });
        return (<table style={_style}>
                    {list}
                </table>);

	}
};

FormItemTable.defaultProps = {
};

export default FormItemTable;


// WEBPACK FOOTER //
// ./src/formItem/FormItemTable.js